import {
  CardComponentProps,
  ProductCardPriceRange,
  UnitPriceInfo,
} from "@~/types/types";
import styles from "./Price.module.scss";
import { transformBlindPrice } from "./priceUtils";
import {
  isMeteredProduct,
  isM2MRomanBlindOrCurtain,
} from "../../../utils/product";
import JLDSPrice from "@JohnLewisPartnership/jl-design-system/dist/components/price/Price";
import { PDPLink } from "../PDPLink/PDPLink";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

type PricePresentationProps = Pick<
  CardComponentProps,
  "product" | "configProps"
> & {
  transformedVariantPrice: ProductCardPriceRange;
  creditMessage: string | undefined;
  unitPriceInfo?: UnitPriceInfo | null;
};

export function PricePresentation({
  transformedVariantPrice,
  creditMessage,
  product,
  configProps,
  unitPriceInfo,
}: PricePresentationProps) {
  const isM2MRollerBlind =
    product.configurationRequirements?.type?.includes(
      "MadeToMeasureRollerBlind",
    ) || false;

  const price = isM2MRollerBlind
    ? transformBlindPrice(transformedVariantPrice)
    : transformedVariantPrice;

  const pricePrefix = isM2MRollerBlind ? "Blind price from" : undefined;

  const priceSuffix =
    isMeteredProduct(product) || isM2MRomanBlindOrCurtain(product)
      ? "per metre"
      : undefined;

  const hasDiorPromosEnabled = !!configProps?.hasDiorPromosEnabled || false;

  const brand = product.brand?.name.toLocaleLowerCase();
  const brandName = brand === "anyday" || brand === "dior" ? brand : "";

  const priceElement = (
    <JLDSPrice
      {...(brandName && { brand: brandName })}
      className={cx("price", {
        "price--responsive": configProps?.isResponsive,
      })}
      dataTestIdPrefix="product-card"
      hasDiorPromosEnabled={hasDiorPromosEnabled}
      price={price}
      creditMessage={creditMessage}
      isProductCardDetailed
      pricePrefix={pricePrefix}
      priceSuffix={priceSuffix}
      {...(unitPriceInfo && { unitPriceInfo })}
    />
  );

  return (
    <PDPLink
      product={product}
      componentName="Price"
      tabIndex={-1}
      className={cx("price__container")}
      noFollow={configProps?.noFollow === true}
    >
      {priceElement}
    </PDPLink>
  );
}
